// Push Editor Advanced Form
import React from 'react';
import { useAppSelector as useSelector } from 'hooks/reduxHooks';
import { getIcon } from '@flybits/design-system';
import { EVENT_KEYS } from 'types/events';

import AdvancedForm from 'components/ExperienceCanvas/TouchpointEditor/TouchpointTimelineBox/PushEditorBox/AdvancedForm';

type TAdvancedPushProps = {
  classPrefix: string;
  onToggle: () => void;
  stepIdx: number;
  isExpanded: boolean;
};

export default function PushEditorAdvancedForm({
  classPrefix = '',
  onToggle,
  stepIdx,
  isExpanded = false,
}: TAdvancedPushProps) {
  const ruleRepeatSchedule = useSelector((state) => {
    const frequency = state.te.rule.startSchedulerMap[0]?.frequency;
    return frequency && frequency > 0;
  });
  const pushActionType = useSelector((state) => {
    const pushRefId = state.te.journey.steps[stepIdx]?.push;
    return pushRefId && state.te.push.byRefId[pushRefId]?.actionType;
  });

  const shouldRender = pushActionType !== 'broadcast-push' && !ruleRepeatSchedule;

  return (
    <>
      {shouldRender && (
        <div className={`${classPrefix}__advanced`}>
          <div
            className={`${classPrefix}__advanced-header`}
            onClick={onToggle}
            onKeyDown={(e) => {
              if (e.key === EVENT_KEYS.ENTER) {
                onToggle();
              }
            }}
            aria-label={'toggle advanced push settings'}
            role="button"
            tabIndex={0}
          >
            Advanced Settings
            {getIcon(isExpanded ? 'baselineKeyboardArrowUp' : 'baselineKeyboardArrowDown', {})}
          </div>
          {isExpanded ? <AdvancedForm classPrefix={classPrefix} stepIdx={stepIdx} /> : null}
        </div>
      )}
    </>
  );
}
